import { GET_REFERRALS } from '../actionTypes';

const initialState = {
  referrals: []
};

const referralsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REFERRALS:
      return {
        ...state,
        referrals: action.payload
      };
    default: {
      return state;
    }
  }
};

export default referralsReducer;
